import React, { Component } from 'react'
import dateFormat from 'dateformat'
import createDateObjects from './createDateObjects'
import IconChevronDown from 'components/Icons/ChevronDown'
import * as PropTypes from 'prop-types'
import cn from 'classnames'
import classes from './Calendar.scss'

export default class Calendar extends Component {
  static propTypes = {
    weekOffset: PropTypes.number.isRequired,
    type: PropTypes.string, // 'datepicker'

    selectedDate: PropTypes.object,
    viewDate: PropTypes.object.isRequired,

    renderDay: PropTypes.func,
    onNextMonth: PropTypes.func.isRequired,
    onPrevMonth: PropTypes.func.isRequired,
    onPickDate: PropTypes.func,
  }

  static defaultProps = {
    weekOffset: 0,
    renderDay: day => dateFormat(day, 'd'),
  }

  render() {
    const days = ['M', 'T', 'W', 'T', 'F', 'S', 'S']
    const {
      className,
      selectedDate,
      viewDate,
      type,
      weekOffset,
      renderDay,
      onNextMonth,
      onPrevMonth,
      onPickDate,
    } = this.props

    const calendarObject = createDateObjects(viewDate, weekOffset)

    calendarObject.forEach(item => {
      if (
        selectedDate &&
        dateFormat(item.day, 'shortDate') === dateFormat(selectedDate, 'shortDate')
      ) {
        item.classNames = item.classNames ? `${item.classNames} selected` : 'selected'
      }
      if (dateFormat(item.day, 'shortDate') === dateFormat(new Date(), 'shortDate')) {
        item.classNames = item.classNames ? `${item.classNames} current` : 'current'
      }
    })

    const calendarClasses = cn(className, classes.calendar, {
      [classes.calendarDatepicker]: type === 'datepicker',
    })

    return (
      <div className={calendarClasses}>
        {type === 'datepicker' && (
          <div className={classes.calendarHeader}>
            <button onClick={onPrevMonth}>
              <IconChevronDown size={14} />
            </button>
            <div className={classes.calendarHeaderCurrentDate}>
              {dateFormat(viewDate, 'mmm')} {dateFormat(viewDate, 'yyyy')}
            </div>
            <button onClick={onNextMonth}>
              <IconChevronDown size={14} />
            </button>
          </div>
        )}
        <div className={classes.calendarGrid}>
          {days.map((day, idx) => (
            <div key={idx} className={cn(classes.calendarGridItem, classes.dayHeader)}>
              {day}
            </div>
          ))}
          {calendarObject.map((day, i) => (
            <div
              key={`day-${i}`}
              className={cn(day.classNames, classes.calendarGridItem)}
              onClick={() => onPickDate(dateFormat(day.day, 'dd/mm/yyyy'))}
            >
              <span>{renderDay(day.day)}</span>
            </div>
          ))}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/DatePicker/Calendar.jsx